const CancelResetDeviceIcon = ({ className, title }) => (
  <svg
    aria-hidden={title ? undefined : 'true'}
    className={className}
    fill='none'
    height='22'
    role={title ? 'img' : undefined}
    viewBox='0 0 22 22'
    width='22'
    xmlns='http://www.w3.org/2000/svg'
  >
    {title && <title>{title}</title>}
    <path
      d='M5.2 14.8A7.2 7.2 0 1 0 4.6 9'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.8'
    />
    <path
      d='M4.4 19.2V14.6H9'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.8'
    />
  </svg>
)

export default CancelResetDeviceIcon
